import * as React from 'react'
import { cn } from '@/lib/utils'

// Avatar + AvatarStack — ui.jsx:151-168.
export interface AvatarPerson {
  id?: string | number
  name: string
  initial: string
  color: string
  you?: boolean
  pending?: boolean
}

export interface AvatarProps {
  person: AvatarPerson
  size?: number
  className?: string
  style?: React.CSSProperties
}

export function Avatar({ person, size = 30, className, style }: AvatarProps) {
  return (
    <span
      title={person.name + (person.you ? ' (you)' : '')}
      className={cn('inline-flex shrink-0 items-center justify-center rounded-full border-2 border-surface font-bold text-white', className)}
      style={{ width: size, height: size, fontSize: size * 0.42, background: person.color, ...style }}
    >
      {person.initial}
    </span>
  )
}

export function AvatarStack({ people, size = 30 }: { people: AvatarPerson[]; size?: number }) {
  return (
    <div className="flex">
      {people.map((p, i) => (
        <Avatar
          key={p.id ?? i}
          person={p}
          size={size}
          className="relative"
          style={{ marginLeft: i ? -8 : 0, zIndex: people.length - i, opacity: p.pending ? 0.5 : 1 }}
        />
      ))}
    </div>
  )
}
